import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { UserStore } from '@shared/stores/user.store';
import { OKTA_AUTH } from '@okta/okta-angular';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonFunctionsService {

  // DI Services
  private readonly router: Router = inject(Router);
  private readonly userStore = inject(UserStore);
  private readonly oktaAuth = inject(OKTA_AUTH);

  // Service Properties
  currentRoute$: WritableSignal<string> = signal<string>('');

  // Service Actions
  initializeRouteTracking(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoute$.set(event.urlAfterRedirects);
      });
  }

  async handleLogout(): Promise<void> {
    try {
      // Optional: clear the local store before/after Okta logout
      this.userStore.clearUserState();

      await this.oktaAuth.signOut(); // Logout via Okta
      // If your flow doesn’t automatically redirect:
      // window.location.href = '/';
    } catch (err) {
      console.error('Logout failed:', err);
      // Simple fallback
      localStorage.clear();
      sessionStorage.clear();
      window.location.reload();
    }
  }
}
